module.exports = "/_next/static/images/basketballIconActive@3x-4a5db8c5e92f04d50d12ff39ee90c36b.png";